import TeachingQualifications from "@/pages/medewerkers/$userId/teaching_qualifications/TeachingQualifications"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"
import { PageHeader } from "toptaal-shared"

export const Route = createFileRoute(
  "/beheer/medewerkers/$userId/lesbevoegdheid/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "employees"),
})

function RouteComponent() {
  const { userId } = useParams({
    from: "/beheer/medewerkers/$userId/lesbevoegdheid/",
  })

  return (
    <>
      <PageHeader className="mb-2">Lesbevoegdheid</PageHeader>

      <TeachingQualifications type="userDetail" userId={Number(userId)} />
    </>
  )
}
